export const GET_ALL_SALE_PLAN = `query GetAllSalePlanning(
  $input: VSalePlanningListViewWhereInput
  $skip: Float
  $take: Float
) {
  getSalePlanningListView(where: $input, skip: $skip, take: $take, orderBy:{implementationDate: ASC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      saleStartedDate
      saleEndDate
      implementationDate
      routeId
      expectedRevenue
      plantId
      teamId
      teamName
      cityId
      tripId
      tripName
      teamCapacity
      teamCapacityId
      actualRevenue
      routeName
      createId
      statusId
      statusName
      createName
      createDate
      modifyDate
      modifyName
      teamSalesId
    }
  }
}
`;

export const GET_ALL_SALE_PLAN_NEW = `
  query GetAllSalePlanning(
    $input: GetSalesPlanningListInput
    $skip: Float
    $take: Float
  ) {
    getSalesPlanningList(where: $input, skip: $skip, take: $take) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        saleStartedDate
        saleEndDate
        implementationDate
        implementationEndDate
        numExpectedDays
        routeId
        expectedRevenue
        plantId
        teamId
        teamName
        cityIds
        tripId
        tripName
        teamCapacity
        routeId
        routeName
        statusId
        statusName
        createName
        createDate
        modifyDate
        modifyName
        tsalesPlanningCusts{
          id
        }
        teamSalesId
      }
    }
  }
`;

export const QUERY_ADD_CUSTOM_SALEPLAN = `mutation CreateManySalePlanning($input: [TsalesPlanningCustInput!]!){
    createManySalesPlanningCust(input: $input){
        customerId
        salesPlanningId
        useYn
        createId
        createDate
        indexNum
    }
}`;

// Get search customer by not SalePlannings
export const QUERY_SEARCH_NOT_CUSTOMER_SALEPLAN = `query GetCustomerNotInPlanning($input: CustNotInPlanningInput!, $skip: Float, $take: Float){
    getCustomerNotInPlanning(where: $input, skip: $skip, take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            customerId
            sapCustomerId
            storeName
            cityId
            phone
            districtId
            latitude
            longitude
            address
            cityName
            districtName
            wardName
            isInArea
            rankName
            taxId
            cccd
        }
    }
} `;

export const UPDATE_SALE_PLANNING = `
  mutation UpdateAllSalePlanning($input: TsalesPlanningInput!){
    updateSalesPlanning(input: $input){
        id
        name
        plantId
        createDate
        expectedRevenue
        implementationDate
        saleEndDate
        saleStartedDate
        unitMoney
        statusId
    }
  }
`;

export const QUERY_GET_DASHBORAD_TEAMSALE = `
  query GetDasshboardByTeamSale($input: DashboardSalesPlanningInput, $skip: Float, $take: Float){
      getDashboardSalesPlanning(where: $input, skip: $skip, take: $take){
          items{
              id
              name
              implementationDate
              saleStartedDate
              saleEndDate
              teamSalesId
              teamCapacity
              teamSales{
                  id
                  teamCapacity
              }
              tsalesPlanningCusts{
                  id
                  customerId
                  useYn
              }
              route{
                  trouteDetails{
                      t2
                      t3
                      t4
                      t5
                      t6
                      t7
                      cn
                      week1
                      week2
                      week3
                      week4
                  }
              }
              statusId
          }
      }
  }
`;

export const QUERY_CREATE_DASHBOARD_TEAM_SALE = `mutation GenerateSalesPlanning($input: GenerateDataInput!){
    generateSalesPlanning(input: $input){
        code
        success
        message
    }
}`;

export const UPDATE_SALE_PLANNING_INDEX = `
  mutation UpdateSalePlanning($input: [TsalesPlanningCustInput!]!){
      updateManySalesPlanningCust(input: $input){
          id
          indexNum
      }
  }
`;

export const CREATE_SALE_PLANNING = `
  mutation CreateAllSalePlanning($input: TsalesPlanningInput!){
    createSalesPlanning(input: $input){
        name
        plantId
        createDate
        expectedRevenue
        implementationDate
        saleEndDate
        saleStartedDate
        unitMoney
        routeId
        teamSalesId
        
    }
  }
`;

export const CHECK_EXIST_SALE_PLANNING = `
  query CheckExistedSalePlanning($input:TsalesPlanningWhereInput!){
      getSalesPlanning(where:$input){
          items{
              id
              plantId
              teamSalesId
              implementationDate
          }
      }
  }
`;

export const CHECK_CREATE_SALE_PLANNING = `
  query CheckExistedSalePlanning($input:checkSalePlanningInput!){
      checkSalePlanningCreate(where: $input){
        message
        status
      }
  }
`;

export const EXPORT_SALE_PLANNING = `
  query ExportSalePlannings(
    $input: GetSalesPlanningListInput
  ) {
    getSalesPlanningExport(where: $input) {
      items {
        id
        saleStartedDate
        saleEndDate
        implementationDate
        routeId
        expectedRevenue
        plantId
        teamId
        teamName
        cityIds
        tripId
        tripName
        teamCapacity
        routeId
        routeName
        unitMoney
        statusId
        statusName
        createName
        createDate
        modifyDate
        modifyName
        teamSalesId
      tcustomer{
          id
          sapCustomerId
          storeName
          taxId
          address
          phone
          trank{
              id
              name
          }
          tcity{
              id
              name
          }
          tdistrict{
              id
              name
          }
          tward{
              id
              name
          }
      }
      }
    }
  }
`;

// update many  sale planning customer revenue
export const UPDATE_MANY_SALE_PLANNING_CUSTOMER = `
  mutation UpdateManySalesPlanningCust($input: [TsalesPlanningCustInput!]!){
      updateManySalesPlanningCust(input: $input){
          id
          averageRevenue
      }
  }
`;
